/**
 * Table heading data
 *
 * @package Embark
 * @since   1.0.0
 */

import $ from 'jquery';


const initTableData = () => {
	const table = $('table');
	if (table.hasClass('em-pipeline-table')) {
		return;
	}
	$('table').wrap('<div class="table-wrapper"></div>');
	$('td').wrapInner('<div></div>');
	$('table').each(function () {
		let headerCount = $(this).find('thead th').length;
		let isTD = false;
		if (!headerCount > 0) {
			headerCount = $(this).find('thead td').length;
			isTD = true;
		}

		for (let i = 0; i <= headerCount; i++) {
			let headerLabel = $(this).find(`thead th:nth-child(${i})`).text();

			if (isTD) {
				headerLabel = $(this).find(`thead td:nth-child(${i})`).text();
			}

			$(this).find(`tr td:not([colspan]):nth-child(${i})`).replaceWith(function () {
				return $(`<td data-label="${headerLabel}">`).append($(this).contents());
			});
		}
	});
};

document.addEventListener('DOMContentLoaded', initTableData);
